/**
 * An episode's identity on the client, mirroring server/api-util/episodes.js.
 *
 * An episode keeps a permanent `episodeId` on its metadata entry
 * (listing publicData.exceptions[]); a Reschedule moves it to a new time slot
 * and remembers the old ones in `previousExceptionIds`. So a booking, a link or
 * a chat card holding any of those ids still finds the episode, at its current
 * time.
 */
export const episodeKeyOf = entry => (entry ? String(entry.attributes?.episodeId || entry.id) : null);

export const resolveEpisode = (listing, anyId) => {
  if (!anyId) return null;
  const id = String(anyId);
  const entries = listing?.attributes?.publicData?.exceptions || [];
  return (
    entries.find(e => String(e?.id) === id) ||
    entries.find(e => e?.attributes?.episodeId && String(e.attributes.episodeId) === id) ||
    entries.find(e => (e?.attributes?.previousExceptionIds || []).map(String).includes(id)) ||
    null
  );
};

const timeOf = value => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? new Date(n) : value ? new Date(value) : null;
};

/** The episode's current start and end, or null when it is not found. */
export const episodeTimes = (listing, anyId) => {
  const entry = resolveEpisode(listing, anyId);
  if (!entry) return null;
  const start = timeOf(entry.attributes?.start);
  const end = timeOf(entry.attributes?.end);
  return start && end ? { start, end } : null;
};
